import React, { useState } from 'react';
import Select from '../Select';
import styles from './wax-stamp.module.css';

// Assuming these atoms exist; adjust import paths if different.
import Knob from '../Knob';
import { Label } from '../Label';
import { useLocale } from '../../context/LocaleContext';

const WaxStamp = ({
  price = 1,
  description = 'Seal your gift bag with a personalised stamp',
  title = 'Add a wax stamp',
  options = [
    { label: 'Doodle Heart', value: 'doodle-heart' },
    { label: 'Initial A', value: 'initial-a' },
    { label: 'Initial B', value: 'initial-b' }
  ],
  required = true,
  enabled: enabledProp,
  onToggle,
  design: designProp,
  onDesignChange,
  className = ''
}) => {
  const [enabledState, setEnabledState] = useState(!!enabledProp);
  const [designState, setDesignState] = useState(designProp || '');
  const { formatPrice } = useLocale();

  const controlledEnabled = enabledProp !== undefined;
  const enabled = controlledEnabled ? enabledProp : enabledState;

  const controlledDesign = designProp !== undefined;
  const design = controlledDesign ? designProp : designState;

  const handleToggle = (next) => {
    if (!controlledEnabled) setEnabledState(next);
    if (typeof onToggle === 'function') onToggle(next);
  };

  const handleDesign = (val) => {
    if (!controlledDesign) setDesignState(val);
    if (typeof onDesignChange === 'function') onDesignChange(val);
  };

  return (
    <div className={`${styles.card} ${enabled ? styles.enabled : ''} ${className}`}>
      <div className={styles.headerRow}>
        <div className={styles.titles}>
          <div className={styles.titleRow}>
            <h4 className={styles.title}>{title}</h4>
            {price ? <span className={styles.price}>{formatPrice({ amount: price })}</span> : null}
          </div>
          {description && <p className={styles.desc}>{description}</p>}
        </div>
        <Knob
          isEnabled={enabled}
          onChange={() => handleToggle(!enabled)}
          aria-label={`${enabled ? 'Remove' : 'Add'} wax stamp`}
        />
      </div>

      {enabled && (
        <div className={styles.body}>
          <Label htmlFor="wax-stamp-design" className={styles.selectLabel}>
            Select Initial or Design {required && <span className={styles.req}>*</span>}
          </Label>
          <Select
            id="wax-stamp-design"
            name="wax_stamp_design"
            options={options}
            value={design}
            onChange={handleDesign}
            placeholder="Choose design"
            className={styles.select}
          />
        </div>
      )}
    </div>
  );
};

export default WaxStamp;
